import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-complaints-view',
  templateUrl: './complaints-view.component.html',
  styleUrls: ['./complaints-view.component.scss']
})
export class ComplaintsViewComponent implements OnInit {

  constructor() { }
  public contactEmail: string = environment.emails.contact_email;
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {
  }

}
